export default "__VITE_ASSET__DoMQmhlK__"